import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=c3d46006&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=c3d46006&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d46006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3d46006')) {
      api.createRecord('c3d46006', component.options)
    } else {
      api.reload('c3d46006', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=c3d46006&scoped=true", function () {
      api.rerender('c3d46006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/OrderDetail.vue"
export default component.exports